import { Routes } from "@angular/router";
import { AdminGuard } from "../domain/security/AdminGuard";
import { AuthGuard } from "../domain/security/AuthGuard";
import { ClientGuard } from "../domain/security/ClientGuard";
import { FactoryGuard } from "../domain/security/FactoryGuard";
import { AdminLayoutComponent } from "./admin/layout/admin-layout.component";
import { ClientLayoutComponent } from "./client/layout/client-layout.component";
import { FactoryLayoutComponent } from "./factory/layout/factory-layout.component";
import { LayoutAuthComponent } from "./shared/layout/layout-auth.component";
import { ProfilePageComponent } from "./shared/pages/profile/profile-page.component";

export const routes: Routes = [
	{ path: "", pathMatch: "full", redirectTo: "/auth" },
	{
		path: "auth",
		component: LayoutAuthComponent,
		loadChildren: () =>
			import("./shared/pages/auth/auth.routes").then((m) => m.AUTH_ROUTES),
	},

	{
		path: "admin",
		component: AdminLayoutComponent,
		canActivate: [AdminGuard],
		loadChildren: () =>
			import("./admin/pages/admin.routes").then((m) => m.ADMIN_ROUTES),
	},
	{
		path: "factory",
		component: FactoryLayoutComponent,
		canActivate: [FactoryGuard],
		loadChildren: () =>
			import("./factory/pages/factory.routes").then((m) => m.FACTORY_ROUTES),
	},
	{
		path: "client",
		component: ClientLayoutComponent,
		canActivate: [ClientGuard],
		loadChildren: () =>
			import("./client/pages/client.routes").then((m) => m.CLIENT_ROUTES),
	},
	{
		path: "profile",
		component: ProfilePageComponent,
		canActivate: [AuthGuard],
	},
];
